<template>
  <el-dialog v-loading="loading" title="申请修改投保单" :visible.sync="dialogVisible" width="40%" top="10px">
    <el-row class="py-1">
      <el-col :span="6" class="font-weight-bold">投保单名称</el-col>
      <el-col :span="18">{{ appform.name }}</el-col>
    </el-row>
    <el-row class="py-1">
      <el-col :span="6" class="font-weight-bold">保险公司</el-col>
      <el-col :span="18">{{ appform.company_name }}</el-col>
    </el-row>
    <el-form :rules="rules" ref="dataForm" :model="form" label-position="left" label-width="90px" class="mx-4">
      <!-- 修改原因 -->
      <el-form-item label="修改原因" prop="reason">
        <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 12 }" v-model="form.reason"
          placeholder="请输入修改原因，不少于5个字"></el-input>
      </el-form-item>
      <el-form-item label="修改内容" prop="content">
        <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 12 }" v-model="form.content"
          placeholder="请输入修改原因"></el-input>
      </el-form-item>
      <el-form-item>
        <span class="float-right">
          <el-button size="small" @click="cancelData">取消</el-button>
          <el-button size="small" type="primary" @click="confirmData">提交</el-button>
        </span>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import { createAppFormModifyApplication } from "@/api/form"

export default {
  name: "form-modify-application-dialog",
  data() {
    return {
      dialogVisible: false,
      loading: false,
      appform: {},
      form: {},
      rules: {
        reason: [
          { required: true, message: "请填写修改原因", trigger: "blur" },
          { min: 5, message: '长度必须大于5', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    handleOpen(appform) {
      this.dialogVisible = true
      this.appform = appform
    },
    confirmData() {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          // 检查证书的有效性
          this.form.appform = this.appform.id
          this.loading = true

          createAppFormModifyApplication(this.form).then(() => {
            this.$message.success("创建修改投保单申请成功")
            this.$nextTick(() => {
              this.$refs.dataForm.resetFields()
              this.dialogVisible = false
              this.$emit("updateList")
            })
            this.loading = false
          }).catch(error => {
            this.loading = false
            this.$error_message(error)
          })
        }
      })
    },
    cancelData() {
      this.$refs.dataForm.resetFields()
      this.dialogVisible = false
    },
  },
}
</script>
  